import React, { useEffect, useState } from 'react';
import { FaSearch, FaTrash, FaPlus } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function CreateUser() {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(100);

    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [userIdToDelete, setUserIdToDelete] = useState(null);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('user');
    const [accessPages, setAccessPages] = useState([]);

    const allPages = [
        "Banner-list", "Section-list", "category-list", "sub-category-list", "product-list", "discount-list", "Video-list", "SubcategoryOffer-List", "Delivery-List", "SizeChart-List", "Contact-List", "order-list", "Shipment-list", "Courier-list"  
    ];

    const fetchUsers = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/users`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const result = await res.json();
            setUsers(result?.data || []);
        } catch (err) {
            console.error('Error fetching users:', err);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const filteredUsers = users.filter(user =>
        Object.values(user).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const currentUsers = filteredUsers.slice(indexOfLastItem - itemsPerPage, indexOfLastItem);
    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

    const handleCreateUser = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/CreateUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ email, password, role, accessPages })
            });
            if (!res.ok) throw new Error('Failed to create user');
            fetchUsers();
            resetForm();
            setShowModal(false);
        } catch (err) {
            console.error(err);
        }
    };

    const resetForm = () => {
        setEmail('');
        setPassword('');
        setRole('user');
        setAccessPages([]);
    };

    const handleDeleteClick = (id) => {
        setUserIdToDelete(id);
        setShowDeleteModal(true);
    };

    const handleDeleteUser = async () => {
        const token = localStorage.getItem('authToken');
        try {
            await fetch(`${process.env.REACT_APP_API_URL}/users/${userIdToDelete}`, {
                method: 'DELETE',
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchUsers();
            setShowDeleteModal(false);
        } catch (err) {
            console.error('Error deleting user:', err);
        }
    };

    const toggleAccess = (page) => {
        setAccessPages(prev =>
            prev.includes(page) ? prev.filter(p => p !== page) : [...prev, page]
        );
    };

    return (
        <div className="container" style={{ marginTop: '80px' }}>
            <h2 className="text-primary">User Management</h2>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="input-group me-3" style={{ maxWidth: '300px' }}>
                    <span className="input-group-text bg-primary text-white">
                        <FaSearch />
                    </span>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search users..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <button className="btn btn-success" onClick={() => setShowModal(true)}>
                    <FaPlus /> Add User
                </button>
            </div>

            <table className="table table-bordered table-striped">
                <thead className="table-primary">
                    <tr>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Access Pages</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentUsers.map((user, i) => (
                        <tr key={i}>
                            <td>{user.AdminEmail}</td>
                            <td>{user.role}</td>
                            <td>
                                {user.accessPages?.map((page, idx) => (
                                    <span key={idx} className="badge bg-info me-1">{page}</span>
                                ))}
                            </td>
                            <td>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteClick(user.id)}>
                                    <FaTrash /> Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <nav>
                <ul className="pagination justify-content-center">
                    {[...Array(totalPages)].map((_, i) => (
                        <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                                {i + 1}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            {/* Add User Modal */}
            <Modal show={showModal} onHide={() => { setShowModal(false); resetForm(); }}>
                <Modal.Header closeButton>
                    <Modal.Title>Add User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Role</Form.Label>
                            <Form.Select value={role} onChange={(e) => setRole(e.target.value)}>
                                <option value="admin">Admin</option>
                                <option value="manager">Manager</option>
                                <option value="user">User</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Access Pages</Form.Label>
                            <div className="d-flex flex-wrap">
                                {allPages.map((page) => (
                                    <div key={page} className="form-check me-3">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={accessPages.includes(page)}
                                            onChange={() => toggleAccess(page)}
                                            id={page}
                                        />
                                        <label className="form-check-label" htmlFor={page}>{page}</label>
                                    </div>
                                ))}
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowModal(false); resetForm(); }}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleCreateUser}>
                        Create
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this user?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                    <Button variant="danger" onClick={handleDeleteUser}>Delete</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CreateUser;
